import { Box, FormControl, FormLabel, Slider, TextField } from '@mui/material';
import { useState, useEffect } from 'react';

export const SliderWithInput = ({
  id,
  title,
  value,
  minValue,
  maxValue,
  onChange,
}: {
  id: string;
  title: string;
  value: number | undefined;
  minValue: number;
  maxValue: number;
  onChange: (value: number) => void;
}) => {
  const safeValue = getValueInRange(value, minValue, maxValue);
  const [textValue, setTextValue] = useState(`${safeValue}`);

  useEffect(() => {
    setTextValue(`${safeValue}`);
  }, [safeValue]);

  return (
    <FormControl size='small' className='w-full'>
      <FormLabel id={id}>{title}</FormLabel>
      <Box className='flex'>
        <Slider
          size='small'
          className='flex-grow mr-[24px]'
          min={minValue}
          max={maxValue}
          value={safeValue}
          onChange={(e, newValue) => onChange(newValue as number)}
          aria-labelledby={id}
          marks={[
            { value: minValue, label: minValue },
            {
              value: maxValue,
              label: (
                <Box className='absolute -translate-x-full' component='span'>
                  {maxValue}
                </Box>
              ),
            },
          ]}
        />
        <TextField
          sx={{ width: '120px' }}
          className='mt-[12px]'
          value={textValue}
          size='small'
          onChange={(event) => setTextValue(event.target.value)}
          onBlur={() => {
            const newValue = getValueInRange(textValue, minValue, maxValue);
            onChange(newValue);
            setTextValue(`${newValue}`);
          }}
          inputProps={{
            min: minValue,
            max: maxValue,
            type: 'tel',
            'aria-labelledby': id,
          }}
        />
      </Box>
    </FormControl>
  );
};

export const getValueInRange = (
  value: number | string | undefined,
  min: number,
  max: number
) => {
  let v = +(value || '');
  v = isNaN(v) ? min : v;
  return Math.min(Math.max(v, min), max);
};
